import { Map, fromJS } from 'immutable';

export function request(state) {
    return state
        .set('state', 'IN_PROGRESS')
        .set('master-ladder', fromJS({}));
}

export function error(state, {errors}) {
    return state
        .set('state', 'ERROR')
        .setIn(['master-ladder', 'errors'], fromJS(errors));
}

export function finish(state, {prices}) {
    return state
        .set('state', 'FINISHED')
        .setIn(['master-ladder', 'prices'], fromJS(prices));
}
